/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WebApiServicesDataTransferObjectsGroupServiceAddNoteDto
 */
export interface WebApiServicesDataTransferObjectsGroupServiceAddNoteDto {
    /**
     * 
     * @type {string}
     * @memberof WebApiServicesDataTransferObjectsGroupServiceAddNoteDto
     */
    text?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WebApiServicesDataTransferObjectsGroupServiceAddNoteDto
     */
    memberId?: number;
}

/**
 * Check if a given object implements the WebApiServicesDataTransferObjectsGroupServiceAddNoteDto interface.
 */
export function instanceOfWebApiServicesDataTransferObjectsGroupServiceAddNoteDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiServicesDataTransferObjectsGroupServiceAddNoteDtoFromJSON(json: any): WebApiServicesDataTransferObjectsGroupServiceAddNoteDto {
    return WebApiServicesDataTransferObjectsGroupServiceAddNoteDtoFromJSONTyped(json, false);
}

export function WebApiServicesDataTransferObjectsGroupServiceAddNoteDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiServicesDataTransferObjectsGroupServiceAddNoteDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'text': !exists(json, 'text') ? undefined : json['text'],
        'memberId': !exists(json, 'memberId') ? undefined : json['memberId'],
    };
}

export function WebApiServicesDataTransferObjectsGroupServiceAddNoteDtoToJSON(value?: WebApiServicesDataTransferObjectsGroupServiceAddNoteDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'text': value.text,
        'memberId': value.memberId,
    };
}

